import { $ } from './utils.js';
import { T, lang, registerTypeBeanText } from './i18n.js';
import { typeText } from './effects.js';

/* ─── Contact Form ────────────────────── */
let turnstileToken = null;

window.onTurnstileSuccess = function(token) {
	turnstileToken = token;
};

$('#contact-form').addEventListener('submit', async function(e) {
	e.preventDefault();
	const form = e.target;
	const status = $('#form-status');
	status.className = 'form-status';
	status.style.display = 'none';

	if (!form.checkValidity()) {
		form.reportValidity();
		return;
	}

	// Turnstile renders in interaction-only mode — if it already has a token
	// (invisible challenge passed) we proceed, otherwise it'll show the UI
	// in place when needed.
	const token = turnstileToken || (typeof turnstile !== 'undefined' ? turnstile.getResponse() : null);
	if (!token) {
		// No token yet — Turnstile UI is already visible; wait for user.
		return;
	}

	const data = {
		name: form.name.value.trim(),
		email: form.email.value.trim(),
		website: form.website.value.trim(),
		message: form.message.value.trim(),
		turnstileToken: token || '',
	};

	const submitBtn = form.querySelector('.form-submit');
	const originalText = submitBtn.textContent;
	submitBtn.disabled = true;
	submitBtn.textContent = '...';

	try {
		const res = await fetch('/api/contact', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(data),
		});

		if (res.ok) {
			status.textContent = T[lang].formOk;
			status.className = 'form-status success';
			form.reset();
			turnstileToken = null;
			if (typeof turnstile !== 'undefined') turnstile.reset();
		} else {
			throw new Error('Server error');
		}
	} catch (err) {
		status.textContent = T[lang].formErr;
		status.className = 'form-status error';
	} finally {
		submitBtn.disabled = false;
		submitBtn.textContent = originalText;
	}
});

// ─── Bean hero typewriter ──────────────
const beanTexts = {
	en: 'Hello. My name is Bean, expert Web Developer at your service.',
	nl: 'Hallo. Mijn naam is Bean, expert webontwikkelaar tot uw dienst.',
};
let firstType = true;

function typeBeanText(l) {
	const startDelay = firstType ? 1500 : 300;
	firstType = false;
	// Use floating Bean bubble instead of hero speech bubble
	const bubble = $('#bean-float-bubble');
	if (bubble) {
		const text = beanTexts[l] || beanTexts.en;
		bubble.classList.add('docked-mode');
		if (typeof window._setBubbleSize === 'function') window._setBubbleSize(text, true);
		bubble.textContent = text.charAt(0);
		// Fade in bubble as first character paints
		setTimeout(() => {
			bubble.classList.add('show');
			typeText(bubble, text, { startDelay: 0 });
		}, startDelay);
	}
}

// Register with i18n so applyLang can call it
registerTypeBeanText(typeBeanText);

/* ─── Bean click → how it works ─────── */
const heroMascotClick = document.querySelector('.mascot');
if (heroMascotClick) heroMascotClick.addEventListener('click', () => {
	document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' });
});
